import { render, staticRenderFns } from "./StudentTree.vue?vue&type=template&id=d1da7174"
import script from "./StudentTree.vue?vue&type=script&lang=js"
export * from "./StudentTree.vue?vue&type=script&lang=js"
import style0 from "./StudentTree.vue?vue&type=style&index=0&id=d1da7174&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports